import * as yup from 'yup';
import { isCnpjValid } from '../../../../utils/common';

const schema = yup.object().shape({
  razao_social: yup.string().required('A razão social deve ser preenchida'),
  cnpj: yup
    .string()
    .required('O CNPJ deve ser preenchido')
    .test('is-cnpj-valid', 'O CNPJ digitádo é inválido', (value) => {
      if (value) {
        return isCnpjValid(value);
      }

      return false;
    }),
  tipo_empresa: yup.string().required('Tipo de empresa é obrigatória.'),
  tipo_tributacao: yup.string().required('Tipo de tributação é obrigatória.'),
  cep: yup.string().required('CEP é obrigatório.'),
  cidade: yup.string().required('Cidade é obrigatório.'),
  estado: yup.string().required('Estado é obrigatório.'),
  logradouro: yup.string().required('Logradouro é obrigatório.'),
  numero: yup.string().required('Número é obrigatório.'),
  cnae: yup
    .string()
    .required('CNAE')
    .test('length', 'CNAE consiste em 7 dígitos.', (cnae) => {
      if (!cnae) {
        return false;
      }
      return !(cnae.length < 7 || cnae.length > 7);
    }),
});

export default schema;
